<template>
  <VModal :isActive="isActive" @clickModal="cancel">
    <div>
      <b-form-textarea
        class="input"
        v-model="tmp"
        placeholder="JSON"
      />
      <br />
      <b-button variant="success" size="sm" @click="ok">OK</b-button>
      <b-button variant="danger" size="sm" @click="cancel">Cancel</b-button>
    </div>
  </VModal>
</template>
<script>
export default {
  props: {
    isActive: Boolean,
    text: String
  },
  watch: {
    text(val) {
      this.tmp = val;
    }
  },
  data() {
    return {
      tmp: ""
    };
  },
  methods: {
    ok() {
      this.$nextTick(() => {
        this.$emit("ok", {
          text: this.tmp
        });
      })
    },
    cancel() {
      this.$emit("cancel");
    }
  }
};
</script>
<style lang="scss" scoped>
.input {
  width: 100%;
  height: 100px;
  margin-bottom: 5px;
}
</style>
